import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartEmptyStateVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 780 340",
	style: { enableBackground: "new 0 0 780 340" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M334.5,266.8h23v4.2h-23V266.8z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M368.2,264.6h23v6.4h-23V264.6z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M401.9,190.4h23V271h-23V190.4z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M435.6,154.3h23V271h-23V154.3z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M469.3,162.8h23V271h-23V162.8z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M502.9,124.6h23V271h-23L502.9,124.6z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M536.6,167h23v104h-23V167z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M570.3,217.9h23V271h-23V217.9z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M604,164.9h23V271h-23V164.9z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M637.7,196.7h23V271h-23V196.7z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#FFFFFF",
				stroke: "#E1E1E1",
				strokeWidth: 2,
				strokeMiterlimit: 10
			},
			d: "M671.4,226.4h23V271h-23V226.4z"
		}) })
	] })
});
export default SvgChartEmptyStateVertical;
